import React from 'react'

import {Badge} from '@vio/atlas/Badge'

interface BrandBellIconProps {
  className?: string
}

export const BrandBellIcon = ({className}: BrandBellIconProps) => (
  <span className={className}>
    <Badge variant="accent" iconName="Bell" />
  </span>
)
